import styled from 'styled-components';
import {textCss} from '../../styles/text.styled';

export const H1 = styled.h1`
  ${textCss};
  margin: 0;
`;
export const H2 = styled.h2`
  ${textCss};
  margin: 0;
`;

export const H3 = styled.h3`
  ${textCss};
  margin: 0;
`;

export const H4 = styled.h4`
  ${textCss};
  margin: 0;
`;

export const H5 = styled.h5`
  ${textCss};
  margin: 0;
`;

export const P = styled.p`
  ${textCss};
  margin: 0;
`;
